import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["required"]
const _hoisted_2 = {
  key: 0,
  class: "invalid-feedback"
}

import { ref, unref } from 'vue'
import { message } from '@/plugins/message'


export default /*#__PURE__*/_defineComponent({
  __name: 'InputCsv',
  props: {
  required: { type: Boolean, default: false }
},
  emits: ["change"],
  setup(__props, { emit }: { emit: ({
  (event: 'change', csv: string): void
}), expose: any, slots: any, attrs: any }) {



// eslint-disable-next-line func-call-spacing


const fileRef = ref<HTMLInputElement>()
const error = ref('')
const acceptMimeTypes = ['text/csv', 'application/vnd.ms-excel']
const upload = () => {
  const input = unref(fileRef) as HTMLInputElement
  error.value = ''
  if (input.files) {
    if (input.files.length === 0) {
      error.value = message('validation.fileIsRequired')
    } else {
      const file = input.files[0]
      if (!acceptMimeTypes.includes(file.type) || !/.csv$/.test(file.name)) {
        error.value = message('validation.isNotCSV')
      } else {
        const reader = new FileReader()
        reader.onloadend = async() => {
          const csv = reader.result as string
          input.setCustomValidity('')
          emit('change', csv)
        }
        reader.readAsText(file)
        return
      }
    }
  }
  input.setCustomValidity(error.value)
  emit('change', '')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", _mergeProps(_ctx.$attrs, {
      ref_key: "fileRef",
      ref: fileRef,
      type: "file",
      class: "form-control",
      accept: ".csv",
      onChange: upload,
      required: __props.required
    }), null, 16, _hoisted_1),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})